// サーバ側のコード
// https://github.com/Liquid-dev/liquid-ekyc-platform/blob/main/app/domain/entities/id_doc_type.go

enum IdDocType {
  Unknown = 0,
  DriversLicenseHo = 1,
  DriversLicenseTo = 21,
  DriversLicenseTi = 31,
  MyNumberCardHo = 2,
  MyNumberCardTo = 22,
  MyNumberCardTi = 32,
  ResidenceCardHo = 3,
  ResidenceCardTo = 23,
  ResidenceCardTi = 33,
  PassportHo = 4,
  PassportTo = 24,
  PassportTi = 34,
  SpecialPermanentResidentCertificateHo = 5,
  SpecialPermanentResidentCertificateTo = 25,
  SpecialPermanentResidentCertificateTi = 35,
  DrivingHistoryCertificateHo = 6,
  DrivingHistoryCertificateTo = 26,
  DrivingHistoryCertificateTi = 36,
  HealthInsuranceCardTo = 27,
  HealthInsuranceCardTi = 37,
  PhysicalDisabilityCertificateBookTo = 28,
  PhysicalDisabilityCertificateCardTo = 29,
  SpecialEducationBookTo = 2010,
  SpecialEducationCardTo = 2011,
  MentalDisabilityCertificateBookTo = 2012,
  MentalDisabilityCertificateCardTo = 2013,
  PensionBookTo = 2014,
  BasicPensionNumberNotificationTo = 2015,
  PassportAnyIssuanceDateTo = 2016,
  BasicResidentRegistrationCardTo = 2017,
  StudentIDCardTo = 2018,
  StudentNotebookTo = 2019,
  PhysicalDisabilityCertificateBookTi = 38,
  PhysicalDisabilityCertificateCardTi = 39,
  SpecialEducationBookTi = 3010,
  SpecialEducationCardTi = 3011,
  MentalDisabilityCertificateBookTi = 3012,
  MentalDisabilityCertificateCardTi = 3013,
  PensionBookTi = 3014,
  BasicPensionNumberNotificationTi = 3015,
  PassportAnyIssuanceDateTi = 3016,
  BasicResidentRegistrationCardTi = 3017,
  StudentIDCardTi = 3018,
  StudentNotebookTi = 3019,
  MnGeneral = 90,
  GpGeneral = 91,
  DriversLicenseGlobalFace = 11001,
  NationalIdentityCardGlobalFace = 11002,
  ResidenceCardGlobalFace = 11003,
  PassportGlobalFace = 11004,
  PhilIDGlobalFace = 11101,
  TINIDGlobalFace = 11102,
  SSSIDGlobalFace = 11103,
  UMIDGlobalFace = 11104,
  UMID2GlobalFace = 11105,
  DriversLicenseGlobalNoFace = 12001,
  NationalIdentityCardGlobalNoFace = 12002,
  ResidenceCardGlobalNoFace = 12003,
  PassportGlobalNoFace = 12004
}

export default IdDocType;
